export default __webpack_public_path__ + "images/0xdbf31df14b66535af65aac99c32e9ea844e14501.png";